import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

@Injectable({ providedIn: 'root' })
export class GoogleAnalyticsService {
  private initialized = false;

  init(): void {
    if (this.initialized) return;
    if (!environment.gaId) return;

    // Create dataLayer + gtag stub before script loads
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () {
      window.dataLayer.push(arguments);
    };

    // Inject script
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${environment.gaId}`;
    document.head.appendChild(script);

    // Configure
    window.gtag('js', new Date());
    window.gtag('config', environment.gaId, {
      // Optional: keep it strict (no auto pageview; we'll send on route change)
      send_page_view: false
    });

    this.initialized = true;
  }

  trackPage(path: string): void {
    if (!this.initialized) return;
    window.gtag('config', environment.gaId, { page_path: path });
  }
}
